/* Solara desktop mega menu (snippets/solara-desktop-menu.liquid).
   - Hovering a category row (after a short intent delay) or focusing it shows that
     category's prints; a click follows the row's link as usual.
   - Images sit in data-sdm-srcset until the pointer or focus reaches the header: the
     dropdown is laid out on every page, so plain <img> tags would load ~50 photos per visit.
   - The print cards themselves sit in <template data-sdm-tpl> and are built by load() at the
     same moment (category rows and links stay in the page for search engines).
   Opening/closing stays with the theme's <mega-menu> element (assets/menu-dropdown.js). */
(function () {
  if (window.__sdmReady) return;
  window.__sdmReady = true;

  function load(scope) {
    if (!scope) return;
    // Print cards ship inside <template> (keeps every page's DOM small); build them on first use.
    scope.querySelectorAll('template[data-sdm-tpl]').forEach(function (t) {
      t.parentNode.replaceChild(t.content, t);
    });
    scope.querySelectorAll('img[data-sdm-srcset]').forEach(function (img) {
      img.srcset = img.getAttribute('data-sdm-srcset');
      img.src = img.getAttribute('data-sdm-src');
      img.removeAttribute('data-sdm-srcset');
    });
  }

  // Row thumbnails, the gift cards row and every menu's first pane: as soon as the visitor heads for the header.
  var warmed = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    document.querySelectorAll('[data-sdm]').forEach(function (root) {
      root.querySelectorAll('.sdm__thumb, .sdm__photo, .sdm__gc-thumb, [data-sdm-pane="1"]').forEach(load);
    });
  }
  function inHeader(el) {
    return el && el.closest && el.closest('.shopify-section-header, .header-wrapper, sticky-header');
  }
  document.addEventListener('pointerover', function (e) { if (inHeader(e.target)) warm(); }, { passive: true });
  document.addEventListener('focusin', function (e) { if (inHeader(e.target)) warm(); });

  function activate(row) {
    var root = row.closest('[data-sdm]');
    if (!root || row.hasAttribute('data-active')) return;
    var key = row.getAttribute('data-sdm-tab');
    root.querySelectorAll('[data-sdm-tab]').forEach(function (r) {
      if (r === row) r.setAttribute('data-active', '');
      else r.removeAttribute('data-active');
    });
    root.querySelectorAll('[data-sdm-pane]').forEach(function (p) {
      var on = p.getAttribute('data-sdm-pane') === key;
      p.hidden = !on;
      if (on) load(p);
    });
    // The white header background was sized when the menu opened; panes can differ in height.
    var mm = root.closest('mega-menu');
    if (mm && mm.header && mm.classList.contains('is-active') && typeof mm.showSublist === 'function') mm.showSublist();
  }

  // Where the theme's white header background ends, relative to the panel (see the CSS).
  function syncGap(mm) {
    var root = mm && mm.querySelector('[data-sdm]');
    var dd = mm && mm.querySelector('.list-menu-dropdown');
    var header = document.querySelector('.shopify-section-header');
    if (!root || !dd || !header) return;
    var gap = Math.max(0, Math.round(header.getBoundingClientRect().bottom - dd.getBoundingClientRect().top));
    root.style.setProperty('--sdm-gap', gap + 'px');
  }

  var timer = null;
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var row = t.closest('[data-sdm-tab]');
    clearTimeout(timer);
    if (row) {
      // The pointer is in the rail: fetch the rest of this menu's photos now.
      load(row.closest('[data-sdm]'));
      timer = setTimeout(function () { activate(row); }, 90);
      return;
    }
    // Opening a menu always starts on its first row.
    var mm = t.closest('mega-menu.is-solara');
    if (mm) syncGap(mm);
    if (mm && !mm.classList.contains('is-active')) {
      var first = mm.querySelector('[data-sdm-tab]');
      if (first) activate(first);
    }
  }, { passive: true });

  document.addEventListener('focusin', function (e) {
    var mmf = e.target && e.target.closest && e.target.closest('mega-menu.is-solara');
    if (mmf) syncGap(mmf);
    var row = e.target && e.target.closest && e.target.closest('[data-sdm-tab]');
    if (!row) return;
    load(row.closest('[data-sdm]'));
    activate(row);
  });
})();
